import { RANGE_END, RANGE_START } from './constants';
import type { DiffSegment, ExtractedRangeMarkers, RangeMarker } from './types';

/**
 * Extracts range markers from a DiffSegment array, returning:
 * - normalized: The changes array with RANGE_START/RANGE_END markers removed
 * - rangeMarkers: Array of marker objects with type, offset, and id
 *
 * Range markers are expected to be 'insert' operations where the text is
 * exactly RANGE_START or RANGE_END (pre-normalized by upstream functions).
 *
 * The offset represents the character position in the final rendered text
 * (where all changes contribute to length: inserts, deletes, and equals).
 */
export function extractRangeMarkers(changes: DiffSegment[]): ExtractedRangeMarkers {
  const normalized: DiffSegment[] = [];
  const rangeMarkers: RangeMarker[] = [];
  let offset = 0;

  for (const change of changes) {
    if (change.op === 'insert' && change.text === RANGE_START) {
      rangeMarkers.push({
        id: change.id,
        offset,
        type: 'start',
      });
      continue;
    }

    if (change.op === 'insert' && change.text === RANGE_END) {
      rangeMarkers.push({
        id: change.id,
        offset,
        type: 'end',
      });
      continue;
    }

    normalized.push(change);
    offset += change.text.length;
  }

  return { normalized, rangeMarkers };
}
